var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EVRYTOKEN-new-ci") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0155233359%",
    y1: "49.9874721%",
    x2: "100.000967%",
    y2: "49.9874721%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71CFF5",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC440",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000635977392%",
    y1: "49.9769135%",
    x2: "99.991282%",
    y2: "49.9769135%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71CFF5",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC440",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yeild-Farm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.-Farm-+-Stake-ready",
    transform: "translate(-505.000000, -222.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EVRYTOKEN-new-ci",
    transform: "translate(505.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#232156",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25438147,14.5393722 L4.92390733,14.8828393 C5.20744603,15.0284575 5.54665437,15.0284575 5.83019307,14.8828393 L14.8658812,10.2516962 C15.5449246,9.90406974 16.3564898,9.90406974 17.0355332,10.2516962 L26.1566102,14.8922752 C26.438594,15.0359083 26.7750901,15.0359083 27.0570739,14.8922752 L27.7401844,14.5393722 C27.8999895,14.4573876 28,14.2961201 28,14.120418 C28,13.9447159 27.8999895,13.7834484 27.7401844,13.7014637 L17.0316519,8.26071981 C16.3526085,7.9130934 15.5410433,7.9130934 14.8619999,8.26071981 L4.25438147,13.7071253 C4.09759932,13.7900424 4,13.9496977 4,14.1232487 C4,14.2967998 4.09759932,14.4564551 4.25438147,14.5393722 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1571487,17.7006687 L17.1550811,22.6047012 C16.4763778,22.973262 15.6652191,22.973262 14.9865158,22.6047012 L8.14525468,18.9211746 C7.98552957,18.8342527 7.88556917,18.6632735 7.88556917,18.4769905 C7.88556917,18.2907074 7.98552957,18.1197283 8.14525468,18.0328064 L8.79504841,17.6786596 C9.07896177,17.5235666 9.41890657,17.5235666 9.70281994,17.6786596 L14.8740142,20.497828 C15.5532351,20.8670914 16.3652982,20.8670914 17.0445192,20.497828 L23.8334088,16.8383113 C23.9931339,16.7513894 24.0930943,16.5804102 24.0930943,16.3941272 C24.0930943,16.2078442 23.9931339,16.036865 23.8334088,15.9499431 L17.0096049,12.2764206 C16.3309016,11.9078598 15.5197429,11.9078598 14.8410396,12.2764206 L4.26007012,18.0408097 C4.1001945,18.1271177 4,18.2978585 4,18.4839934 C4,18.6701283 4.1001945,18.840869 4.26007012,18.927177 L14.9903951,24.7235794 C15.6690984,25.0921402 16.4802571,25.0921402 17.1589604,24.7235794 L27.7399299,18.963192 C27.8998055,18.876884 28,18.7061432 28,18.5200083 C28,18.3338734 27.8998055,18.1631326 27.7399299,18.0768246 L27.0629806,17.7106729 C26.7811889,17.5531454 26.4421456,17.549401 26.1571487,17.7006687 L26.1571487,17.7006687 Z M12.0149218,15.9459415 L14.8623761,14.3952988 C15.5410794,14.026738 16.3522381,14.026738 17.0309414,14.3952988 L19.9288274,15.9599473 C20.088703,16.0462553 20.1888975,16.216996 20.1888975,16.4031309 C20.1888975,16.5892659 20.088703,16.7600066 19.9288274,16.8463146 L17.0483985,18.3969573 C16.3696952,18.7655181 15.5585365,18.7655181 14.8798332,18.3969573 L12.0149218,16.830308 C11.8560685,16.7436532 11.7566952,16.5734878 11.7566952,16.3881247 C11.7566952,16.2027616 11.8560685,16.0325963 12.0149218,15.9459415 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvry);
export default __webpack_public_path__ + "static/media/evry.19b78d91967e80603f328d91e0af6ee2.svg";
export { ForwardRef as ReactComponent };